<div class="date-picker-container" [style.justify-content]="justify">

  <div class="frequency-select-L" *ngIf="showFrequency && layout === 'lefty'">
    <div class="format-select">
      <mat-form-field floatLabel="never" [appearance]="selectAppearance"
        style="--padding: {{selectAppearance === 'outline' ? '0' : '1.25rem'}}">
        <mat-select [formControl]="frequencyControl" (selectionChange)="changeFrequency($event.value)"
          [disabled]="tempDisable">
          <mat-option *ngFor="let frequency of frequenciesList" [value]="frequency">
            {{ frequency | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="frequency-select-L" *ngIf="showAggregation && layout === 'lefty'">
    <div class="format-select">
      <mat-form-field floatLabel="never" [appearance]="selectAppearance"
        style="--padding: {{selectAppearance === 'outline' ? '0' : '1.25rem'}}">
        <mat-select [formControl]="aggregationControl" (selectionChange)="changeAggregation($event.value)"
          [disabled]="tempDisable">
          <mat-option *ngFor="let aggregation of aggregationList" [value]="aggregation">
            {{ formatAggregation(aggregation) | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>


  <div class="date-select">
    <button mat-icon-button color="primary" (click)="changeDate(-1)"
      [disabled]="!tempDisable ? (!canChangeWith(-1) || !choiceSet) : tempDisable">
      <mat-icon svgIcon="arrow_left"></mat-icon>
    </button>

    <div class="date-label">{{ getCurrentDate() }}</div>

    <button mat-icon-button color="primary" (click)="changeDate(1)"
      [disabled]="!tempDisable ? (!canChangeWith(1) || !choiceSet) : tempDisable">
      <mat-icon svgIcon="arrow_right"></mat-icon>
    </button>

    <button mat-icon-button color="primary" (click)="choiceSet ? picker.open() : pickerRange.open()">
      <mat-icon svgIcon="calendar"></mat-icon>
    </button>

    <!--The real date picker input field is hidden and is controlled by the arrows and button-->
    <mat-form-field class="hidden-input">
      <input matInput [formControl]="dateControl" [min]="min" [max]="max" [matDatepicker]="picker"
        (dateChange)="changeDate($event)" />
      <mat-datepicker-toggle matSuffix [for]="picker" [disabled]="tempDisable"></mat-datepicker-toggle>
      <mat-datepicker #picker [startView]="calendarView()" [disabled]="tempDisable"></mat-datepicker>
    </mat-form-field>

    <mat-form-field class="hidden-input">
      <mat-date-range-input [formGroup]="rangeControl" [rangePicker]="pickerRange" [min]="min" [max]="max">
        <input matStartDate formControlName="start">
        <input matEndDate formControlName="end">
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="pickerRange" [disabled]="tempDisable"></mat-datepicker-toggle>
      <mat-date-range-picker #pickerRange (closed)="setDate($event)" [disabled]="tempDisable"></mat-date-range-picker>

      <mat-error *ngIf="rangeControl.controls.start.hasError('matStartDateInvalid')">Invalid start date</mat-error>
      <mat-error *ngIf="rangeControl.controls.end.hasError('matEndDateInvalid')">Invalid end date</mat-error>
    </mat-form-field>
  </div>

  <div class="frequency-select-R" *ngIf="showFrequency && layout === 'righty'">
    <div class="format-select">
      <mat-form-field floatLabel="never" [appearance]="selectAppearance">
        <mat-select [formControl]="frequencyControl" (selectionChange)="changeDate($event.value)"
          [disabled]="tempDisable">
          <mat-option *ngFor="let frequency of frequenciesList" [value]="frequency">
            {{ frequency | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="frequency-select-R" *ngIf="showAggregation && layout === 'righty'">
    <div class="format-select">
      <mat-form-field floatLabel="never" [appearance]="selectAppearance"
        style="--padding: {{selectAppearance === 'outline' ? '0' : '1.25rem'}}">
        <mat-select [formControl]="aggregationControl" (selectionChange)="changeAggregation($event.value)"
          [disabled]="tempDisable">
          <mat-option *ngFor="let aggregation of aggregationList" [value]="aggregation">
            {{ formatAggregation(aggregation) | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
</div>